import styled from '@emotion/styled';
import { mobileOnly, desktopOnly } from '../lib/utils';
import DateLocationLockup from './DateLocationLockup';
import HeroImage from './Layout/HeroImage';
import RSVPButton from './RSVPButton';
import { Maybe } from 'graphql/jsutils/Maybe';

const MobileHeroImage = mobileOnly(HeroImage);
const DesktopHeroImage = desktopOnly(HeroImage);

const VerticalLayoutImageWrapper = styled('div')`
  .horizontalLayout.homePage & {
    display: none;
  }
  flex: 1;
`;

const DesktopVerticalLayoutImageWrapper = desktopOnly(
  VerticalLayoutImageWrapper
);

const HorizontalLayoutImageWrapper = styled('div')`
  .verticalLayout.homePage & {
    display: none;
  }
`;

const DesktopHorizontalLayoutImageWrapper = desktopOnly(
  HorizontalLayoutImageWrapper
);

const PageWrapper = styled('div')`
  display: flex;
  flex-direction: column;

  .verticalLayout.homePage & {
    flex-direction: row-reverse;
    gap: 24px;
  }
`;

const PageContentsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

interface MultiPagePageContentsProps {
  children: React.ReactNode;
  landscapeCrop: Maybe<string> | undefined;
  heroSrc: string | null | undefined;
  isHomePage: boolean;
}

const MultiPagePageContents = ({
  children,
  landscapeCrop,
  heroSrc,
  isHomePage,
}: MultiPagePageContentsProps) => {
  return (
    <PageWrapper>
      {isHomePage && heroSrc && (
        <DesktopVerticalLayoutImageWrapper>
          {/* Only used for the cover photo for the vertical layout on desktop */}
          <DesktopHeroImage
            id="cover-photo"
            src={heroSrc}
            headerOnHero={false}
            landscapeCrop={landscapeCrop}
            data-testid="cover-photo"
            sizes="(min-width: 768px) 100vw, 0vw"
          />
        </DesktopVerticalLayoutImageWrapper>
      )}
      <PageContentsWrapper>
        {isHomePage && (
          <>
            {heroSrc ? (
              <DesktopHorizontalLayoutImageWrapper>
                {/* Only used for the cover photo for the horizontal layout on desktop */}
                <DesktopHeroImage
                  id="cover-photo"
                  src={heroSrc}
                  headerOnHero={false}
                  landscapeCrop={landscapeCrop}
                  data-testid="cover-photo"
                  sizes="(min-width: 768px) 100vw, 0vw"
                />
              </DesktopHorizontalLayoutImageWrapper>
            ) : null}
            {heroSrc ? (
              <MobileHeroImage
                src={heroSrc}
                headerOnHero={false}
                landscapeCrop={landscapeCrop}
                data-testid="cover-photo"
                sizes="(max-width: 767px) 100vw, 0vw"
              />
            ) : null}
            <DateLocationLockup />
            <RSVPButton />
          </>
        )}
        {children}
      </PageContentsWrapper>
    </PageWrapper>
  );
};

export default MultiPagePageContents;
